const localeRuleType = {
  test({ params, rule }) {
    const { locale } = params || {};
    const { language, region } = parseLocale(locale);

    return (
      (!rule.language || language === rule.language.toLowerCase()) &&
      (!rule.region || region === rule.region.toUpperCase())
    );
  },

  validate(rule) {
    if (!('language' in rule || 'region' in rule)) {
      return {
        isValid: false,
        message: 'Must have a language or region property'
      };
    }

    if ('language' in rule && typeof rule.language !== 'string') {
      return {
        isValid: false,
        message: 'Language property must be a language code'
      };
    }

    if ('region' in rule && typeof rule.region !== 'string') {
      return {
        isValid: false,
        message: 'Region property must be a country code'
      };
    }

    return { isValid: true };
  }
};

// Tolerate - vs _, uppercase vs lowercase
const localePattern = /^(\w{2,})[\-_](\w{2,})$/;

// The number of locale inputs should be fairly fixed; cache these parsings
// forever.
const cachedParsings = {};

function parseLocale(locale) {
  if (!locale) {
    return {};
  }

  if (!(locale in cachedParsings)) {
    const match = localePattern.exec(locale);
    cachedParsings[locale] = match
      ? {
          language: match[1].toLowerCase(),
          region: match[2].toUpperCase()
        }
      : {};
  }

  return cachedParsings[locale];
}

module.exports = localeRuleType;
